import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from "components/CustomButtons/Button.js";
import history from '../../../../../history';
import { withStyles } from '@material-ui/core/styles';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { isEmpty } from "lodash";
import Simplert from 'react-simplert';
import { submitOrderPage, getOrderSummary, resetOrderSummary, updateForceUserBack } from '../../../../store/actions';

import { confirmAlert } from "react-confirm-alert";
import '../../../../../../src/assets/css/customAlert.css';
import { withRouter } from "react-router-dom";
import $ from 'jquery';
import { compose } from "redux";
import authService from '../../../../../components/api-authorization/AuthorizeService';

const useStyles = theme => ({
    left: {
        float: "left!important",
        display: "block",
    },
    right: {
        margin: "0",
        float: "right!important",
        display: "block",
    },
    closebuttonPopUp: {
        backgroundColor: "#FF2E2E", border: "none", color: "white", padding: "15px 28px", textAlign: "center",
        textDecoration: "none", display: "inline-block", margin: "13px 2px", cursor: "pointer"
    },
    confirmbuttonPopUp: {
        backgroundColor: "#7ea11d", border: "none", color: "white", padding: "15px 28px", textAlign: "center",
        textDecoration: "none", display: "inline-block", margin: "13px 2px", cursor: "pointer"
    },
});


class StageOneNextBackButtons extends Component {

    state = {
        todaysDate: '',

        deliveryChargeNeeded: false,
        infoDelChargeMessage: false,
        surchargeNeeded: false,
        surchargePercentage: 0,

        //pop up message
        showAlert: false,
        typeAlert: '',
        titleAlert: '',
        messageAlert: '',
        useConfirmBtn: false

    };

    async componentDidMount() {

        await this.props.resetOrderSummary();
        await this.props.updateForceUserBack(true);
        this.GetTodaysDate();
    }

    componentWillUnmount() {

        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    GetTodaysDate() {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();


        today = yyyy + '-' + mm + '-' + dd;

        this.setState({ todaysDate: today });

        this.setState({ todaysDate: today }, () => {

        });

    }


    displayMessage = (type, title, message, useConfrim, isDelCharge) => {
        this.setState({
            showAlert: true,
            typeAlert: type,
            titleAlert: title,
            messageAlert: message,
            useConfirmBtn: useConfrim,
            infoDelChargeMessage: isDelCharge

        }, () => {
            window.scrollTo(0, 0)
        });
    }

    handlePopUpMessage = () => {
        this.setState({ showAlert: false });
    }


    handleConfirm = () => {
        this.setState({ showAlert: false });

        if (this.state.infoDelChargeMessage === true) {
            this.setState({ deliveryChargeNeeded: true }, () => {

            });
        }
        else {
            this.setState({ deliveryChargeNeeded: false }, () => {

            });
        }
    }
    OnConfirmDelChargeRes = async (tonnesValue) => {

        //const { show } = await Confirm.new();

        let tonnesMessage = typeof tonnesValue === "string"
            ? "For orders less than " + tonnesValue + ", a delivery charge applies. Do you wish to proceed?"
            : "For orders less than " + tonnesValue + " tonnes, a delivery charge applies. Do you wish to proceed?";

        //const result = await show({
        //    title: tonnesMessage
        //});

        //if (result) {
        //    this.setState({ deliveryChargeNeeded: true }, () => {
        //    });
        //    return true;
        //} else {
        //    this.setState({ deliveryChargeNeeded: false }, () => {
        //    });
        //    return false;
        //}

        var self = this;

        return new Promise(function (resolve, reject) {

            confirmAlert({
                closeOnClickOutside: false,
                customUI: ({ onClose }) => {
                    return (
                        <div className='custom-ui'>
                            <h3><b>Delivery Charge</b></h3>
                            <h5>{tonnesMessage}</h5>
                            <button onClick={() => {
                                self.setState({ deliveryChargeNeeded: true }, () => { });
                                onClose();
                                resolve(true);
                            }}>Yes</button>

                            <button onClick={() => {
                                self.setState({ deliveryChargeNeeded: false }, () => { });
                                onClose();
                                resolve(false);
                            }}>No</button>
                        </div>
                    );
                }
            });

        });

    }


    OnConfirmSurchargeResult = async (percent, minvalue, maxvalue) => {

        //const { show } = await Confirm.new();

        //const result = await show({
        //    title: 'For orders between ' + minvalue + ' tonnes and ' + maxvalue + ' tonnes, a ' + percent + '% surcharge applies. Do you wish to proceed?'
        //});

        //if (result) {
        //    this.setState({ surchargeNeeded: true, surchargePercentage: percent }, () => { });
        //    return true;
        //}
        //else {
        //    this.setState({ surchargeNeeded: false }, () => { });
        //    return false;
        //}

        let message = 'For orders between ' + minvalue + ' tonnes and ' + maxvalue + ' tonnes, a ' + percent + '% surcharge applies. Do you wish to proceed?';
        var self = this;

        return new Promise(function (resolve, reject) {

            confirmAlert({
                closeOnClickOutside: false,
                customUI: ({ onClose }) => {
                    return (
                        <div className='custom-ui'>
                            <h3><b>Surcharge</b></h3>
                            <h5>{message}</h5>
                            <button onClick={() => {
                                self.setState({ surchargeNeeded: true, surchargePercentage: percent }, () => { });
                                onClose();
                                resolve(true);
                            }}>Yes</button>

                            <button onClick={() => {
                                self.setState({ surchargeNeeded: false }, () => { });
                                onClose();
                                resolve(false);
                            }}>No</button>
                        </div>
                    );
                }
            });

        });

    }

    ResetStates = async () => {

        this.setState({
            deliveryChargeNeeded: false,
            surchargeNeeded: false,
            surchargePercentage: 0
        }, () => { });

    }

    // Add this new method - calls the pricing endpoint and returns the order value directly
    async FetchOrderValue(productsSelectedList) {
        try {
            const token = await authService.getAccessToken();

            const forPricing = productsSelectedList.map(p => ({
                ...p,
                packs: parseInt(p.packs),
                totalWeight: parseFloat(p.totalWeight)
            }));

            const response = await fetch('api/orderprocess/getordersummary/', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    customerId: this.props.user.customerId,
                    branchId: this.props.branchInfo == null ? null : this.props.branchInfo.id,
                    deliverySiteId: this.props.deliverySiteInfo.id,
                    QuoteId: this.props.selectedQuoteId ? parseInt(this.props.selectedQuoteId) : null,
                    totalWeight: this.props.totalWeight,
                    surchargeNeeded: false,
                    surchargePercentage: 0,
                    selectedProducts: forPricing,
                    cusOrderNumber: this.props.cusOrderNumber,
                    reqDelDate: this.props.reqDelDate,
                    specialInstructions: this.props.specialInstructions
                })
            });

            const res = await response.json();
            return res.original_Total_price ?? res.Original_Total_price ?? 0;

        }
        catch (e)
        {
            console.error("Failed to fetch order value", e);
            return 0;
        }
    }

    SubmitButtonClicked = async () => {
        //VALIDATION START
        await this.ResetStates();

        var productsAdded = false;


        for (var i in this.props.productList) {

            if (this.props.productList[i].quantity > 0) {
                productsAdded = true;
                break;
            }
        }

        if (productsAdded === false) {
            //error - no products added
            this.displayMessage("error", "No Products Added", "Please add products from the below table in order to proceed to the summary page", false, false);
            return;
        }

        let maxOrderWeight = parseFloat(this.props.maxOrderWeight);

        if (maxOrderWeight === 0) {
            maxOrderWeight = 28;
        }

        if (this.props.totalWeight > maxOrderWeight) {
            //error            
            this.displayMessage("error", maxOrderWeight + " Tonne Weight Limit Exceeded", "This order has exceeded the maximum weight limit of " + maxOrderWeight + " tonnes. Please amend before proceeding", false, false);
            return;
        }


        if (this.props.selectedDeliverySiteId === 0) {
            //error
            this.displayMessage("error", "No Delivery Site", "This order has no delivery site selected. Please select a delivery site before proceeding", false, false);
            return;
        }

        if (this.props.reqDelDate === '') {
            //error
            this.displayMessage("error", "No Requested Delivery Date", "This order has no requested delivery date. Please select a valid date before proceeding", false, false);
            return;
        }


        if (this.props.reqDelDate < this.state.todaysDate) {
            //error 
            this.displayMessage("error", "Invalid Delivery Date", "The requested delivery date must be in the future. Please amend date before proceeding", false, false);
            return;
        }

        var branchName;



        if (isEmpty(this.props.branchInfo)) {
            branchName = "";
        }
        else {
            branchName = this.props.branchInfo.displayText.toLowerCase();
        }

        //ADD SELECTED PRODUCTS TO THEIR OWN LIST

        var productsSelectedList = [];

        for (var j in this.props.productList) {
            if (this.props.productList[j].quantity > 0) {

                productsSelectedList.push(this.props.productList[j]);

            }

        }
        if (this.props.deliverySiteInfo.displayText.toLowerCase().includes('collect') || branchName.includes('ex works') || this.props.deliverySiteInfo.collectionDiscount === true) {
            //order being collected, dont worry about weight 
        }
        else {

            //NO LONGER NEEDED
            ////check here for bagged products part load
            //if (this.props.totalWeight < 25) {
            //    const baggedPartLoad = await this.CheckItemsForBaggedPartLoad(productsSelectedList);

            //    if (baggedPartLoad) {
            //        this.displayMessage("error", "Bagged Products", "Bagged products must be part of a mixed load or a full load greater than 25 tonne", false, false);
            //        return;
            //    }
            //}

            let minOrderWeight = parseInt(this.props.minOrderWeight);

            if (minOrderWeight > 0) {

                if (this.props.totalWeight < minOrderWeight) {
                    //error
                    //below min order weight
                    this.displayMessage("error", "Below Minimum Weight", "You are below the minimum order weight. Please add more products before proceeding", false, false);
                    return;
                }
            }

            const althamProductIds = [
                210092, 208285, 208286, 207000, 207001, 208287, 207002, 208288,
                207003, 208289, 207004, 207005, 207008, 207010, 207012, 208292,
                208293, 208294, 207013, 207014, 207018, 207031, 207245, 207073,
                208273, 208274, 208276, 208277, 207037, 207045, 208319, 207163,
                207164, 207165, 208366, 207166, 207020, 208299, 208300, 208301,
                207021, 207022, 208302, 207023, 208303, 208304, 207024, 208305,
                207025, 207026, 207027, 208306, 208280, 207268, 208281, 207269,
                207270, 207271, 208282, 207272, 207273, 208283, 207284, 207285,
                207286, 208310, 207288, 207289, 208337, 207306, 207264, 207029,
                207030, 210078, 212576, 207301, 207038, 207039, 207040, 207041,
                207042, 208315, 208316, 207043, 208317, 208318, 207044, 207050,
                207051, 207052, 207053, 207054, 207055, 207056, 207057, 208320,
                207058, 208321, 207059, 207314, 208352, 207199, 207200
            ];

            const hasAlthamProduct = productsSelectedList.some(p =>
                althamProductIds.includes(parseInt(p.productId))
            );

            // Build productsSelectedList first (you already do this above)...

            let orderValue = 0;

            if (hasAlthamProduct) {
                // Fetch price early so we can check against £400
                orderValue = await this.FetchOrderValue(productsSelectedList);
                //console.log("Fetched order value for Altham check:", orderValue);

                if (orderValue < 400) {
                    const result = await this.OnConfirmDelChargeRes("£400 order value");
                    if (result === false) return;
                }
            }

            //if not an altham product, work as normal
            if (!hasAlthamProduct) {

                if (this.props.totalWeight < 8) {

                    //if just roofing products, we allow them to proceed and pay the delivery charge
                    const allRoofingProducts = await this.CheckItemsForRoofing(productsSelectedList);


                    if (allRoofingProducts === false) {
                        //we have gone in here as there are other product groups added to the cart

                        //next check to see if they are a h&b customer

                        //h&b customers can advance no matter what product groups added

                        const hAndBCustomer = await this.CheckCustomerBuyingGroup();

                        if (!hAndBCustomer) {
                            this.displayMessage("error", "Below Minimum Weight", "You are below the minimum order weight of 8 tonnes. Please add more products before proceeding", false, false);
                            return;
                        }


                    }

                }
            }

            //check list
            //if empty -> check if order is below 8
            //else check orderWeight against rows in table


            if (isEmpty(this.props.customerSurchargesList))
            {

                //if customer has a minimum order weight they do not have to pay delivery charge

                if (!hasAlthamProduct && this.props.totalWeight < 8 && this.props.minOrderWeight === 0)
                {
                    //alert that a surcharge is needed of £50
                    //if they select yes, make note and add this on to product list

                    const result = await this.OnConfirmDelChargeRes(8);

                    if (result === false)
                    {
                        return;
                    }
                    //if customer clicks OK set deliveryChargeNeeded variable to true
                }
            }
            else
            {

                if (!hasAlthamProduct)
                {
                    let row = this.props.customerSurchargesList.find(item => item.minVal <= this.props.totalWeight && item.maxVal > this.props.totalWeight);

                    if (isEmpty(row)) {
                        //continue on as no row found
                    }
                    else {
                        //alert either to say surcharge or delivery charge and save this is redux store so know that it is to be calculated


                        if (row.surcharge === true) {

                            const result = await this.OnConfirmSurchargeResult(parseInt(row.surchargePercentage), parseInt(row.minVal), parseInt(row.maxVal));

                            if (result === false) {
                                return;
                            }


                            //if customer clicks OK set surchargeNeeded variable to true
                        }
                        else {

                            const result = await this.OnConfirmDelChargeRes(row.maxVal);

                            if (result === false) {
                                return;
                            }

                            //if customer clicks OK set deliveryChargeNeeded variable to true
                        }
                    }
                }
            }
        }
        //VALIDATION END

        if (this.state.deliveryChargeNeeded) {
            //add delivery row
            const item = {
                productId: parseInt(4708),
                productName: "P99 DELIVERY CHARGE FENCING",
                productCode: "PRE DELIVERY FENCING",
                category: "",
                weight: parseInt(0),
                units: parseInt(0),
                packSize: parseInt(1),
                packs: parseInt(1),
                totalWeight: parseFloat(0),
                quantity: parseInt(1),
                deliverySiteId: null,
                customerId: parseInt(this.props.user.customerId)
            };
            productsSelectedList.push(item);
        }

        await this.props.updateForceUserBack(false); // ensure user is clicking on the custom buttons rather than browser to calcuate the products correctly if changed
        this.props.submitOrderPage(productsSelectedList, this.state.surchargeNeeded, this.state.surchargePercentage);
        this.GetSummaryOrder(productsSelectedList);

        /*        history.push('/OrderSummary');*/


        this.props.history.push("/OrderSummary");

    }



    async CheckCustomerBuyingGroup() {


        try {
            const token = await authService.getAccessToken();

            const response = await fetch('api/orderprocess/checkforcustomerbuyinggroup/', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    customerId: parseInt(this.props.user.customerId),
                    proceed: false

                })
            });


            const res = await response.json();

            if (res.proceed) {
                return true; //h&b customer, they can continue
            }
            else {
                return false; // not h&b customer, they cant continue
            }

        } catch (e) {
            return false;
        }
    }

    async CheckItemsForRoofing(productsSelectedList) {

        for (let i = 0; i < productsSelectedList.length; i++) {

            productsSelectedList[i].packs = parseInt(productsSelectedList[i].packs);
            productsSelectedList[i].totalWeight = parseFloat(productsSelectedList[i].totalWeight);
        }

        try {
            const token = await authService.getAccessToken();

            const response = await fetch('api/orderprocess/checkforroofingproducts/', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    SelectedProducts: productsSelectedList

                })
            });


            const res = await response.json();

            if (res.onlyRoofingProducts) {
                return true; //only roofing products have been added to the cart
            }
            else {
                return false; // other products and not just roofing products added
            }

        } catch (e) {
            return false;
        }
    }



    async CheckItemsForBaggedPartLoad(productsSelectedList) {

        for (let i = 0; i < productsSelectedList.length; i++) {

            productsSelectedList[i].packs = parseInt(productsSelectedList[i].packs);
            productsSelectedList[i].totalWeight = parseFloat(productsSelectedList[i].totalWeight);
        }

        try {
            const token = await authService.getAccessToken();

            const response = await fetch('api/orderprocess/checkforbaggedproducts/', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    SelectedProducts: productsSelectedList

                })
            });


            const res = await response.json();

            if (res.baggedPartLoad) {
                return true; //stop and throw up a message
            }
            else {
                return false; // allow them to proceed
            }

        } catch (e) {
            return false;
        }
    }


    async GetSummaryOrder(productsSelectedList) {
        try {
            //var productsSelectedList = [];

            //for (var i in this.props.productList) {
            //    if (this.props.productList[i].packs > 0) {

            //        productsSelectedList.push(this.props.productList[i]);

            //    }

            //}

            for (let i = 0; i < productsSelectedList.length; i++) {
                productsSelectedList[i].packs = parseInt(productsSelectedList[i].packs);
                productsSelectedList[i].totalWeight = parseFloat(productsSelectedList[i].totalWeight);
            }


            this.props.getOrderSummary(
                this.props.user.customerId,
                this.props.branchInfo == null ? null : this.props.branchInfo.id,
                this.props.deliverySiteInfo.id,
                this.props.selectedQuoteId,
                this.props.totalWeight,
                this.state.surchargeNeeded,
                this.state.surchargePercentage,
                productsSelectedList,
                this.props.cusOrderNumber,
                this.props.reqDelDate,
                this.props.specialInstructions
            )

        } catch (e) {

        }

    }



    render() {

        const { classes } = this.props;

        let { showAlert, typeAlert, titleAlert, messageAlert, useConfirmBtn } = this.state




        return (
            <GridContainer>

                <Simplert
                    style={{
                        width: '250px;'
                    }}
                    showSimplert={showAlert}
                    type={typeAlert}
                    title={titleAlert}
                    message={messageAlert}
                    onClose={() => this.handlePopUpMessage()}
                    disableOverlayClick={true}
                    useConfirmBtn={useConfirmBtn}
                    customConfirmBtnClass={classes.confirmbuttonPopUp}
                    onConfirm={() => this.handleConfirm()}
                    customCloseBtnClass={classes.closebuttonPopUp}
                />




                <GridItem xs={12} sm={12} md={12} style={{ paddingTop: "40px" }}>
                    <div className={classes.left}>


                        <Button
                            style={{
                                borderRadius: 2,
                                padding: "16px 20px",
                                fontSize: "15px"
                            }}
                            color="danger"
                            size="lg"
                            target="_blank"
                            onClick={() => history.goBack()}
                        >
                            <i className="far fa-window-close"></i>
                            &nbsp; Cancel
                        </Button>
                    </div>


                    {isEmpty(this.props.deliverySiteInfo) ? null :

                        <div className={classes.right}>
                            <Button
                                style={{
                                    borderRadius: 2,
                                    padding: "16px 20px",
                                    fontSize: "15px"
                                }}
                                color="success"
                                size="lg"
                                target="_blank"
                                onClick={this.SubmitButtonClicked}
                            //onClick={() => history.push("/OrderSummary")}
                            >
                                <i className="far fa-hand-point-right"></i>
                                &nbsp; Next
                            </Button>
                        </div>

                    }


                </GridItem>
            </GridContainer>
        )
    }
}

const mapStateToProps = state => {

    return {
        user: state.userReducer.user,
        selectedDeliverySiteId: state.orderReducer.selectedDeliverySiteId,
        reqDelDate: state.orderReducer.reqDelDate,
        totalWeight: state.orderReducer.totalWeight,
        lorryLoad: state.orderReducer.lorryLoad,
        deliverySiteInfo: state.orderReducer.deliverySiteList == null ? null : state.orderReducer.deliverySiteList.find(item => item.id === parseInt(state.orderReducer.selectedDeliverySiteId)),
        selectedQuoteId: state.orderReducer.selectedQuoteId,
        minOrderWeight: state.orderReducer.minOrderWeight,
        maxOrderWeight: state.orderReducer.maxOrderWeight,
        customerSurchargesList: state.orderReducer.customerSurchargesList,
        productList: state.orderReducer.productList,
        branchList: state.orderReducer.branchList,
        branchInfo: state.orderReducer.branchList == null ? null : state.orderReducer.branchList.find(item => item.id === parseInt(state.orderReducer.selectedBranchId)),
        cusOrderNumber: state.orderReducer.cusOrderNumber,
        specialInstructions: state.orderReducer.specialInstructions

    };
};

export default compose(withRouter, connect(mapStateToProps, { submitOrderPage, getOrderSummary, resetOrderSummary, updateForceUserBack }))(withStyles(useStyles)(StageOneNextBackButtons));
